import { KeyedArray } from "./keyedArray";

export interface FilterItem {
	id: number;
	name: string;
	value?: string;
}

export interface FilterItemPascal {
	Id: number;
	Name: string;
}

export const FilterItemArray = <T extends FilterItem>(items?: T[]) => mapToKeyedArray(items || []);

export const mapToKeyedArray = <T extends FilterItem>(items: T[]) => new KeyedArray<T>(items, (i) => i.id);

export const mapToKeyedArrayPascal = <T extends FilterItemPascal>(items: T[]) => new KeyedArray<T>(items, (i) => i.Id);
